import MultiSelectQuestionTemplate from '~/pages/anatomyV2/libs/components/MultiSelectQuestionTemplate'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 6

const SpecificReasonAnatomyV2 = (props: TPageProps) => (
  <MultiSelectQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.specificReason.title"
    options={[
      {
        key: 'impressFriends',
        emoji: '🔥',
        i18nKey: 'onboarding.specificReason.options.impressFriends',
      },
      {
        key: 'freeTime',
        emoji: '📱',
        i18nKey: 'onboarding.specificReason.options.freeTime',
      },
      {
        key: 'routineStress',
        emoji: '🧘',
        i18nKey: 'onboarding.specificReason.options.routineStress',
      },
      {
        key: 'careerLadder',
        emoji: '🚀',
        i18nKey: 'onboarding.specificReason.options.careerLadder',
      },
      {
        key: 'mindInCheck',
        emoji: '😌',
        i18nKey: 'onboarding.specificReason.options.mindInCheck',
      },
      {
        key: 'mostInterestingPerson',
        emoji: '😎',
        i18nKey: 'onboarding.specificReason.options.mostInterestingPerson',
      },
      {
        key: 'broadenHorizons',
        emoji: '⛰️',
        i18nKey: 'onboarding.specificReason.options.broadenHorizons',
      },
    ]}
    question="Do you have a specific reason for self-growth?"
  />
)

export default SpecificReasonAnatomyV2
